import React from "react";

interface Props {
  text: string;
  margin?: string;
  linkUrl?: string;
  padding?: string;
  width?: string;
  clickAble?: boolean;
  textAlign?:
    | "-moz-initial"
    | "inherit"
    | "initial"
    | "revert"
    | "unset"
    | "center"
    | "end"
    | "justify"
    | "left"
    | "match-parent"
    | "right"
    | "start"
    | undefined;
  fs?: string;
  flexGrow?: any;
  color?: string;
  fontWeight?: any; 
  wordSpacing?: string; 
}

const Text: React.FC<Props> = ({
  text,
  fs,
  fontWeight = "300",
  margin,
  textAlign,
  color,
  flexGrow,
  linkUrl,
  clickAble,
  wordSpacing="2px",
  padding,
  width
}) => (
  <span
    style={{
      fontSize: fs,
      color,
      fontWeight,
      margin,
      textAlign,
      flexGrow,
      wordSpacing,
      width,
      padding,
      cursor: clickAble ? "pointer" : "",
    }}
    onClick={() => clickAble && window.open(linkUrl)}
  >
    {text}
  </span>
);

export default Text;
